<template>
  <!-- 综合查询 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems glo_bgcMainColor"
          @click="aaaa"
          >新增
        </el-button>
        <el-button
          v-if="hasPermiss('aaaaa')"
          class="glo_btnItems"
          @click="genzongBtns"
          >客户跟踪</el-button
        >
        <el-button class="glo_btnItems" @click="getMemberInfo"
          >弹窗样式</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <div ref="queryForm">
      <el-form
        :model="queryData"
        :class="isHaseMore ? 'glo_form hasMoreParam' : 'glo_form'"
        label-position="left"
      >
        <el-form-item class="queryItemsTimes">
          <multitime
            :timeType="timeType"
            :timeTypes="timeTypes"
            :startTime="startTime_a"
            :endTime="endTime_a"
            @timestatus="timestatus"
            @queryBtn_ok="queryBtn_time"
          >
          </multitime>
        </el-form-item>
        <el-form-item class="queryItems" label="活动区域">
          <el-input clearable v-model="queryData.name"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="活动区域">
          <el-input clearable v-model="queryData.name"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="活动区域">
          <el-input clearable v-model="queryData.name"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="活动区域">
          <el-input clearable v-model="queryData.name"></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="活动区域">
          <el-select
            filterable
            clearable
            v-model="queryData.region"
            placeholder="活动区域"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="活动区域">
          <el-select
            filterable
            clearable
            v-model="queryData.region"
            placeholder="活动区域"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="活动区域">
          <el-select
            filterable
            clearable
            v-model="queryData.region"
            placeholder="活动区域"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="queryItems" label="活动区域">
          <el-select
            filterable
            clearable
            v-model="queryData.region"
            placeholder="活动区域"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <!-- 某个字段需要单独操作  例如点击可以跳转 -->
          <el-table-column
            v-if="item.field == 'memberNickname' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div class="linkTabel" @click.stop="goYdDetails(scope.row)">
                {{ scope.row.memberNickname }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="280px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button class="rbtns" @click.stop="abc(scope.row)"
                >修改</el-button
              >
              <el-button class="rbtns" @click.stop="abc(scope.row)"
                >拆单</el-button
              >
              <el-button class="rbtns" @click.stop="abc(scope.row)"
                >运输规划</el-button
              >
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
    </paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    >
    </sorttable>

    <!-- 客户跟踪 -->
    <addCustomerTarck
      :showDia1="showDia1"
      :documentNumbers="documentNumbers"
      :documentStatus="documentStatus"
      :isdisabledStatus="true"
      @confirmAdd="confirmAdd"
      @closeDia1="closeDia1"
    ></addCustomerTarck>

    <!-- 弹窗 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef')"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="isShowDialog"
          class="diaForm"
          ref="dialogFormRef"
          :model="dialogForm"
          label-width="100px"
          :rules="rulesForm"
        >
          <el-form-item class="dialogFormItems" prop="aaa" label="活动名称:">
            <el-input v-model="dialogForm.aaa" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogFormItems" prop="bbb" label="活动区域:">
            <el-select v-model="dialogForm.bbb" placeholder="请选择活动区域">
              <el-option label="区域一" value="shanghai"></el-option>
              <el-option label="区域二" value="beijing"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="dislogFormTextarea" prop="ccc" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm.ccc"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片:">
            <uploadimgs
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :limit="6"
            ></uploadimgs>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import multitime from "@/components/multiTime.vue";
import myDialog from "@/components/Dialog.vue";
import queryBtns from "@/components/queryBtns.vue";
import addCustomerTarck from "@/components/CustomerServiceTrackingNew.vue";

import uploadimgs from "@/components/upLoadImgs.vue";
export default {
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    multitime,
    addCustomerTarck,
    myDialog,
    uploadimgs,
    queryBtns,
  },
  data() {
    return {
      //  -----  查询  ------
      queryData: {
        name: "",
        region: "",
      }, //  表单查询数据
      //  时间类型
      timeTypes: [
        {
          value: "0",
          label: "添加日期",
        },
        {
          value: "1",
          label: "入库日期",
        },
        {
          value: "2",
          label: "出库日期",
        },
        {
          value: "3",
          label: "打包日期",
        },
      ],
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",

      MoreConditions: "更多条件", //  输入框绑定动态class
      isHaseMore: false, //false == 更多条件  true ==收起条件

      //      -------  表格  ----------
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "auto", //  表格高度
      selectTableData: [], //  表格选中的数据

      show_sortTableHeard: false, //显示表格设置弹窗
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "会员名称",
          field: "memberNickname",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "会员号",
          field: "memberId",
          width: "120",
          sort: 4,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "快递单号",
          field: "courierNumber",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "出库单号",
          field: "billStorepackNumber",
          width: "160",
          sort: 5,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "转单号",
          field: "billStorepackChannelNumber",
          width: "160",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货架号",
          field: "frameName",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "包裹状态",
          field: "packageStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "会员付款状态",
          field: "storepackStatusShow",
          width: "160",
          sort: 18,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "拒收状态",
          field: "isRejectionShow",
          width: "120",
          sort: 19,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "验货状态",
          field: "checkStatusShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "货物品类",
          field: "itemCategoryShow",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "入库时间",
          field: "intoStockTime",
          width: "180",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "仓库",
          field: "storageName",
          width: "120",
          sort: 2,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "包裹件数",
          field: "boxCount",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "包裹重量",
          field: "packageWeight",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "包裹体积",
          field: "packageVolume",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "包裹备注",
          field: "packageComment",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "打包批次",
          field: "billPackNumber",
          width: "120",
          sort: 180,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "目的地",
          field: "areaCountryName",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "邮编",
          field: "postCode",
          width: "160",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "添加包裹时间",
          field: "packageCreateTime",
          width: "180",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "到库签收时间",
          field: "billSignforCreateTime",
          width: "180",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
        {
          name: "打包时间",
          field: "billStorepackCreateTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },

        {
          name: "出库时间",
          field: "outStockTime",
          width: "120",
          sort: 1,
          isShow: true,
          isTotal: false,
          isSort: true,
        },
      ],
      myTableHeard: [], //  我的表头
      originalTabelHeadeTitle: [], //自定义排序表头(恢复默认用)
      tableData: [
        {
          name: "测试",
          memberNickname: 23432434,
          memberId: "memberId",
        },
        {
          name: "1233333",
          memberNickname: 123,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 234,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
        {
          name: "1233333",
          memberNickname: 153,
          memberId: "自定义排序表头",
        },
      ], //  表格数据

      allCheck: false, //  全选
      sortName: "综合查询模板", //  排序名
      selectLength: 0, //  显示的长度

      totalArr: [], //  表格需要合计的字段
      className: "", //  导出需要
      pageGroupName: "Demo", //  页面标识

      // 新建客服跟踪
      showDia1: false,
      documentNumbers: "",
      documentStatus: "", //包裹单据

      fileNameLists: [], //上传组件的
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "弹窗标题",
      diaWidth: "60%",
      dialogForm: {
        // 弹窗表单数据
        aaa: "",
        bbb: "",
        ccc: "",
      },
      rulesForm: {
        aaa: [
          { required: true, message: "请输入", trigger: ["blur", "change"] },
        ],
      },
      // ==== 弹窗组件属性 end ====
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.myTableHeard = this.tabelHeadeTitle;
    if (this.originalTabelHeadeTitle.length === 0) {
      this.originalTabelHeadeTitle = JSON.parse(
        JSON.stringify(this.tabelHeadeTitle)
      );
    }
    this.startTime_a = this.$TOOLS.getFlexDate(this.$COMMON.timeNum); //开始时间;
    this.endTime_a = this.$TOOLS.getCurrentDate(); //今天的时间;;
  },
  activated() {
    // 每次进页面都会触发的写这里
    this.getData();
  },
  mounted() {
    //计算获取表格高度
    this.fetTableHeight();
  },
  watch: {},
  methods: {
    //  xxx
    abc(a) {},
    aaaa() {},

    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia(a) {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn(a) {
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn(a) {
      this.isShowDialog = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */

    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    // 时间组件 选择时间后触发
    queryBtn_time(s, e) {
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },
    // 时间组件 选择类型后触发
    timestatus(type, s, e) {
      this.timeType = type || "0";
      this.startTime_a = s || "";
      this.endTime_a = e || "";
    },

    // 提交新建客服跟踪
    confirmAdd(formName) {
      this.showDia1 = false;
      this.getData();
    },
    // 关闭客户跟踪弹窗,重置弹窗数据
    closeDia1(e) {
      this.showDia1 = e || false;
      this.documentNumbers = ""; //如果不重置这个,第二次点开同样的数据组件不会监听到变化默认是空的
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    rowclick2(row, event, column) {
      this.$refs.memberTable.toggleRowSelection(row);
    },

    getData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      return false;
      this.$API.packageList(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.fetTableHeight();
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`);
        }
      });
    },

    queryBtn_ok() {
      //  查询按钮
      this.pageStart = 1;
      this.getData();
    },

    clerBtns() {
      //  重置按钮
      this.queryData = {};
    },

    moreParam() {
      this.isHaseMore = !this.isHaseMore;
      if (this.isHaseMore) {
        this.MoreConditions = "收起条件";
      } else {
        this.MoreConditions = "更多条件";
      }

      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    handleSizeChange(val) {
      //  分页
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      //  分页
      this.pageStart = val;
      this.getData();
    },

    AddPackage() {
      //  添加包裹
      this.$router.push({
        path: "/BusinessManagement/addPacks",
      });
    },

    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    ModifyPackage() {
      //  修改包裹
      if (this.selectTableData.length === 1) {
        this.$router.push({
          path: "/BusinessManagement/addPacks",
          query: {
            packageId: this.selectTableData[0].packageId,
          },
        });
      } else {
        this.$message.error("请选一个需要修改的包裹");
      }
    },

    PackageDetails() {
      //  包裹详情
      if (this.selectTableData.length > 0) {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
          query: {
            packageId: this.selectTableData[0].packageId,
            courierNumber: this.selectTableData[0].courierNumber,
          },
        });
      } else {
        this.$router.push({
          path: "/BusinessManagement/packsDetails",
        });
      }
    },
    dabaoDetails() {
      //  包裹详情
      if (this.selectTableData.length === 1) {
        if (
          this.selectTableData[0].packageStatus ==
            "chu_ku_zai_tu:package_status" ||
          this.selectTableData[0].packageStatus ==
            "ke_hu_qian_shou:package_status" ||
          this.selectTableData[0].packageStatus ==
            "chu_ku_zhong:package_status" ||
          this.selectTableData[0].packageStatus ==
            "da_bao_wan_cheng:package_status"
        ) {
          this.$router.push({
            path: "/BusinessManagement/dabaoDetails",
            query: {
              packageId: this.selectTableData[0].packageId,
            },
          });
        } else {
          this.$message.error("包裹未打包完成");
        }
      } else {
        this.$message.error("请选择一个包裹");
      }
    },

    genzongBtns() {
      let str = "";
      this.selectTableData.forEach((item) => {
        str += item.courierNumber + ",";
      });
      if (str.length > 0) {
        str = str.substring(0, str.length - 1);
      }
      this.documentNumbers = str;
      this.documentStatus = "package_v1:document_status"; //包裹单据
      this.showDia1 = true;
    },

    //   -------- 编辑会员 -----------
    getMemberInfo() {
      this.isShowDialog = true;
    },

    /***
     * ==============设置表格动态高度==============
     */
    fetTableHeight() {
      // 重置table高度
      this.tabelHeigth = 0;
      // 设置table高度
      let windonHeight =
        document.body.clientHeight || document.documentElement.clientHeight; //页面高度
      let queryHeigth = 40 + 10; //10==margin-top: 10  查询框高度
      let btnListHeight = this.$refs.btnList.offsetHeight; // 按钮列表高度
      if (this.isHaseMore) {
        queryHeigth = this.$refs.queryForm.offsetHeight + 10; //查询框
      }
      let pagsHeigth = 40 + 20; //分页组件高度 20是上下margin
      var otherHeight = queryHeigth + btnListHeight + pagsHeigth + 60; //60是顶部导航 10是
      let tabHeight = Math.floor(windonHeight - otherHeight) || ""; //

      // this.tableHeigth = tabHeight;
      this.$nextTick(() => {
        this.tableHeigth = tabHeight;
        this.$refs.mytable.doLayout();
      });
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },

    /****
     *  ===================下面页面公共方法 start ===================
     *
     */

    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dyyd") {
        // 打印运单
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // 导出
        this.exportBtn();
      }
    },
    // 点击导出 (页面标识,表头,列表标识,数据源,表名)
    exportBtn() {
      this.$COMAPI.exportBtn({
        pageGroupName: this.pageGroupName, //页面标识
        myTableHeard: this.myTableHeard, //表头数组
        className: this.className, //列表标识
        tableData: this.tableData, //数据源
        sheetName: "表名(暂无效)", //表名
      });
    },
    //点击更多操作下的按钮
    handleCommandBtns(type, val) {

    },

    //    -------------  设置列表表头方法  ------------

    getGroupFindFieldSort() {
      //  获取自定义的排序,没有就用默认的
      this.$API
        .getGroupFindFieldSort({
          groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
        })
        .then((res) => {
          let arr = res.data.result || [];
          if (arr.length > 0) {
            if (arr[0].sortObject) {
              this.myTableHeard = JSON.parse(arr[0].sortObject);
              this.sortName = arr[0].sortName;
            }
          } else {
            this.myTableHeard = this.tabelHeadeTitle;
          }
          let totalArr = [];
          //提取需要合计的字段
          for (var i = 0; i < this.myTableHeard.length; i++) {
            if (this.myTableHeard[i].isTotal) {
              totalArr.push(this.myTableHeard[i].field);
            }
          }
          this.totalArr = totalArr;
        });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },

    // ==========排序表头的组件方法==========
    //   取消按钮(表格设置)
    cancelSortHeard() {
      this.show_sortTableHeard = false;
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
    },
    // 排序==>确认按钮(表格设置)
    confirmOk(e) {
      this.tabelHeadeTitle = e;
      this.myTableHeard = this.tabelHeadeTitle;
      let sortObject = this.myTableHeard;
      let sign = "";
      //   let param = {
      //     groupName: this.pageGroupName, //当前页面表格的标记(自定义字符串)
      //     sortName: this.sortName, //综合查询接口路径
      //     sortObject: JSON.stringify(sortObject),
      //     sign: sign,
      //   };
      //   this.$API.pushFindFieldSort(param).then((res) => {
      //     this.$message.success(res.data.message || "操作成功");
      //     this.getGroupFindFieldSort();
      //   });
      this.show_sortTableHeard = false; //关闭弹窗
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      this.show_sortTableHeard = false;
    },
    // 点击某一项(表格设置)
    checktab(idx, e) {
      let that = this;
      that.tabelHeadeTitle[idx].isShow = e;
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
      if (selectLength == that.tabelHeadeTitle.length) {
        that.allCheck = true;
      } else {
        that.allCheck = false;
      }
    },
    //全选(表格设置)
    checkAll(e) {
      let that = this;
      this.allCheck = e;
      for (var j = 0; j < this.tabelHeadeTitle.length; j++) {
        this.tabelHeadeTitle[j].isShow = e;
      }
      let selectLength = 0;
      for (var i = 0; i < that.tabelHeadeTitle.length; i++) {
        if (that.tabelHeadeTitle[i].isShow) {
          selectLength++;
        }
      }
      that.selectLength = selectLength;
    },
    //关闭弹窗(表格设置)
    closeDias(e) {
      this.show_sortTableHeard = e;
    },

    /****
     *  ===================上面页面公共方法 end ===================
     *
     */
  },
};
</script>
<style scoped lang="less">
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
